// @ts-nocheck
import React, { useEffect, useState } from "react";
import SoftBox from "../../components/common/softBox";
import SoftTypography from "../../components/common/softTypography";
import SoftButton from "../../components/common/softButton";
import SoftInput from "../../components/common/softInput";
import { useDispatch, useSelector } from "react-redux";
import { createCms, getCmsByType } from "../../features/cms";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import { FormControl, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getContactInfo, updateContactInfo } from "../../features/contactInfo";

const ContactInfo = () => {
  const { contactInfo } = useSelector((state) => state.contactInfo);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getContactInfo());
  }, [dispatch]);

  useEffect(() => {
    if (contactInfo &&contactInfo.email && contactInfo.phone) {
      setFormData({
        email: contactInfo.email,
        phone: contactInfo.phone,
      });
    }
  }, [contactInfo]);

  const [formData, setFormData] = useState({
    email: "",
    phone: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // console.log(formData,'formData')

  const handleSubmit = () => {
    dispatch(updateContactInfo(formData)).then((resultAction) => {
      if (updateContactInfo.rejected.match(resultAction)) {
        console.error(resultAction.payload || resultAction.error);
      } else {
        toast.success("Contact info updated successfully!");
      }
    });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />
      <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold">
            Manage Contact Info
          </SoftTypography>
        </SoftBox>

        <SoftBox mb={2}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            Email
          </SoftTypography>
          <SoftInput
            type="email"
            name="email"
            placeholder="Enter contact email"
            value={formData.email}
            onChange={handleChange}
          />
        </SoftBox>

        {/* Phone Input */}
        <SoftBox mb={2}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            Phone
          </SoftTypography>
          <SoftInput
            type="text"
            name="phone"
            placeholder="Enter contact phone"
            value={formData.phone}
            onChange={handleChange}
          />
        </SoftBox>

        {/* Submit Button */}
        <SoftBox mt={4} mb={1}>
          <SoftButton
            variant="gradient"
            color="info"
            fullWidth
            onClick={handleSubmit}
          >
            Submit
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default ContactInfo;
